import { Trans } from '@lingui/react';
import React from 'react';
import '../profile/profile.scss';

interface IProps {
  setShowDeleteModal: (state: boolean) => void;
  applyAll: (global: boolean) => void;
}

const ModalConfirmApplyAll: React.FC<IProps> = ({ setShowDeleteModal, applyAll }) => {
  return (
    <div className='delete-profile-modal-bg'>
      <div>
        <div className='delete-profile-modal-container' style={{ height: '362px' }}>
          <div className='delete-profile-modal-header'>
            <Trans id='Delete account information' />
          </div>
          <div className='delete-profile-modal-body' style={{ marginTop: '30px', padding: '30px 60px' }}>
            <div>
              <Trans id="You're about to apply the changes to ALL your virtual tours. The local settings on your tours would be replaced with the new selected values." />
              <br />
              <div className='delete-profile-modal-text'>
                <Trans id='To Keep the local settings on existing tours, exit the pop-up and press "Save change" button' /> <br />
              </div>
            </div>

            <div style={{ margin: '40px 40px 0px 40px', display: 'flex', gap: '40px' }}>
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                }}
                className='btn-new-design btn-new-cancel'
                id='close-modal-apply'
              >
                <Trans id='Cancel' />
              </button>
              <button
                className='btn-new-design btn-new-active'
                onClick={() => {
                  const global = true;
                  applyAll(global);
                }}
              >
                <Trans id='Apply to all tours' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmApplyAll;
